import React, {useEffect, useState} from 'react';

import Header from "../header";
import WatchVideo from "../watchVideo";
import RenderPack from "../pack/renderPack";

import video from "../../../public/firstScreen/spiro-landing.mp4";
import dessert from '../../../public/firstScreen/dessert.png';
import dishWithDessert from '../../../public/firstScreen/dish-with-dessert.png';
import packMobile from "../pack/packMobile";
import $ from "jquery";
import spiroBlick from '../../../public/models/pack/blick.png';

let canMoveLeft = true;

const getCanMoveLeft = () => canMoveLeft;

const enableMoveLeft = () => {
    canMoveLeft = true;
}

const disableMoveLeft = () => {
    canMoveLeft = false;
}

let canScroll;
const getCanScroll = () => canScroll;
const setCanScroll = (value) => canScroll = value;

const Title = (props) => {
    const {apiData} = props;
    return (
        <h5 className='first-screen__title' dangerouslySetInnerHTML={{__html: apiData.first_screen_title}}>
        </h5>
    )
}

const UnderTitle = (props) => {
    const {apiData} = props;
    // const text = 'Доставляем трансформирующие рационы, созданные на&nbsp;стыке профессиональных знаний о&nbsp;здоровой еде, опыта в&nbsp;дизайне блюд и&nbsp;утонченной кулинарной&nbsp;технике';
    return (
        <p className='first-screen__text' dangerouslySetInnerHTML={{__html: apiData.first_screen_under_title}}>
        </p>
    )
}

export default function FirstScreen(props) {
    const {apiData, packValues, setPackRequestId, firstScreenMobile, disablePackAnimation, setDisablePackAnimation} = props;
    useEffect(() => {
        !firstScreenMobile ? RenderPack(packValues, getCanMoveLeft, setCanScroll, disablePackAnimation, setPackRequestId) : packMobile({image: packValues[0], obj: packValues[1], disablePackAnimation});

        setTimeout(() => {
            $('.first-screen').animate({opacity: 1}, 1000);
            $('.first-screen main').animate({top: 0}, 1000);
        }, 100)

        setTimeout(() => $('.first-screen main').css({position: 'static'}), 1700);

        const dishes = document.getElementsByClassName('food-menu__dish');
        for (let i = 0; i < dishes.length; i++) {
            const images = $(dishes[i]).find('img');
            images.each(function () {
                $(this).attr('src', $(this).data('image'))
            })
        }
    }, []);

    return (
        <section className='first-screen'>
            <div className='watch-video-popup'>
                <video muted={false} playsinline controls={true} type="video/mp4" src={video}/>
            </div>
            <Header isEnglish={apiData.isEnglish} setDisablePackAnimation={setDisablePackAnimation}/>
            <main>
                <Title apiData={apiData}/>
                <UnderTitle apiData={apiData}/>
                <WatchVideo isEnglish={apiData.isEnglish} enableMoveLeft={enableMoveLeft} disableMoveLeft={disableMoveLeft} getCanScroll={getCanScroll}/>
                <div id='dish'>
                    <svg className='spiro-background' width="354" height="86" viewBox="0 0 354 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4" d="M34.5713 85.2741C44.301 85.2741 52.2932 82.2626 57.7372 77.5135C63.1812 72.8804 66.1928 66.2781 66.1928 58.865C66.1928 50.4094 63.6445 44.6179 58.548 40.7955C53.4515 37.089 45.9226 35.0041 35.8454 33.7299C29.4748 32.8033 25.6524 31.645 23.4516 29.9076C21.135 28.4018 20.4401 26.0852 20.4401 23.1894C20.4401 17.6296 24.4941 13.8072 32.8338 13.8072C40.8261 13.8072 45.5751 17.3979 46.6176 24.811L63.8762 24.811C62.3704 8.2474 51.4824 0.0235004 32.8338 0.0235004C23.6833 0.0235004 16.1544 2.68758 10.942 6.97328C5.72969 11.4906 2.71812 17.6296 2.71812 24.6952C2.71812 32.6875 4.80305 38.3631 9.78373 42.1855C14.5327 46.2395 21.9458 48.4403 32.6022 49.8303C38.6253 50.7569 42.5635 51.9152 44.9959 53.421C47.3125 55.1584 48.2392 57.3592 48.2392 60.6024C48.2392 67.0889 42.911 71.6062 34.5713 71.6062C28.4323 71.6062 24.6099 69.9846 22.1775 67.5522C19.7451 65.2356 18.8184 61.7607 18.3551 58.0542H0.401527C0.864846 66.3939 3.76059 73.112 9.32041 77.861C14.8802 82.61 23.1041 85.2741 34.5713 85.2741ZM81.1746 1.1818L81.1746 84H99.8232V53.8843H110.364C119.746 53.8843 127.506 51.7994 132.95 47.5137C138.394 43.228 141.406 36.8573 141.406 28.0543V27.591C141.406 9.98485 130.055 1.1818 109.785 1.1818L81.1746 1.1818ZM109.321 40.7955H99.8232V15.4288L109.321 15.4288C118.24 15.4288 123.337 18.9037 123.337 27.7068V28.1701C123.337 36.5098 118.703 40.7955 109.321 40.7955ZM155.502 1.1818L155.502 84H174.382L174.382 1.1818H155.502ZM194.063 1.1818L194.063 84H212.712L212.712 52.031L220.82 52.031L240.627 84H260.549L238.658 48.7878C243.407 47.3978 247.692 44.9654 250.82 41.3747C253.947 37.784 255.685 33.1508 255.685 26.7802V26.3168C255.685 17.8613 252.557 11.4906 246.997 7.32076C241.438 3.1509 233.445 1.1818 223.716 1.1818L194.063 1.1818ZM223.252 39.2898L212.712 39.2898V15.5447H223.252C232.403 15.5447 237.384 18.4404 237.384 26.896V27.3593C237.384 35.2357 232.635 39.2898 223.252 39.2898ZM310.684 70.3321C303.85 70.3321 298.058 67.668 294.004 62.919C289.834 58.2858 287.402 51.4519 287.402 42.9963V42.0697C287.402 33.7299 289.487 26.896 293.541 22.147C297.595 17.5138 303.155 14.8497 310.452 14.8497C317.749 14.8497 323.425 17.6296 327.479 22.3786C331.302 27.1276 333.502 33.9616 333.502 41.9538V42.8805C333.502 51.2202 331.186 58.17 327.363 62.8032C323.309 67.5522 317.634 70.3321 310.684 70.3321ZM310.336 85.2741C323.309 85.2741 333.966 80.7568 341.379 73.2278C348.792 65.6989 353.077 55.0426 353.077 42.6488V41.7222C353.077 29.2126 348.56 18.9037 341.147 11.4906C333.618 4.19337 322.962 0.0235004 310.452 0.0235004C298.058 0.0235004 287.518 4.42503 279.989 11.8381C272.228 19.2512 267.827 29.7917 267.827 42.1855V43.1121C267.827 55.1584 271.997 65.8147 279.41 73.2278C286.707 80.7568 297.363 85.2741 310.336 85.2741Z" fill="#EBEBEB"/>
                    </svg>
                    <svg className='dish__shadow' width="440" height="184" viewBox="0 0 440 184" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g opacity="0.09" filter="url(#filter0_f)">
                            <path d="M311.18 20L20 90.5205L113.913 164L420 90.5205L311.18 20Z" fill="#1D1D1D"/>
                        </g>
                        <defs>
                            <filter id="filter0_f" x="0" y="0" width="440" height="184" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                <feFlood floodOpacity='0' result="BackgroundImageFix"/>
                                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                                <feGaussianBlur stdDeviation="10" result="effect1_foregroundBlur"/>
                            </filter>
                        </defs>
                    </svg>
                </div>
                <img src={spiroBlick} className='spiro-blick'/>
                <div className='dish__flying-dish'>
                    <img className='dish__dessert' src={dessert}/>
                    <img className='dish__table-dish' src={dishWithDessert}/>
                </div>
            </main>
        </section>
    )
}